import Cookies from "js-cookie";

const SetCookie = (cookiename, token) => {
  const inTweentyFourHours = new Date(new Date().getTime() + 1440 * 60 * 1000);
  Cookies.set(cookiename, token, {
    expires: inTweentyFourHours,
    secure: true,
    sameSite: "strict",
    path: "/",
  });
};
export default SetCookie;
